export const brokerDeserializer = data => {
    const { first_name, last_name, email, npn, phone } = data
    return {
        firstName: first_name,
        lastName: last_name,
        email,
        npn,
        phone,
    }
}
